"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Userwerk = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class Userwerk {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Userwerk.prototype, "enable", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Userwerk.prototype, "campaignKey", void 0);
exports.Userwerk = Userwerk;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlcndlcmsuanMiLCJzb3VyY2VSb290IjoiLi9zcmMvIiwic291cmNlcyI6WyJwYWNrYWdlcy9tb2RlbHMvc3JjL3VzZXJ3ZXJrLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxxQ0FBaUM7QUFFakMsTUFBYSxRQUFRO0NBS3BCO0FBSkc7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLENBQUM7O3dDQUNYO0FBQ2hCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxDQUFDOzs2Q0FDUDtBQUp4Qiw0QkFLQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbHVtbiB9IGZyb20gXCJ0eXBlb3JtXCI7XG5cbmV4cG9ydCBjbGFzcyBVc2Vyd2VyayB7XG4gICAgQENvbHVtbih7IGRlZmF1bHQ6IGZhbHNlIH0pXG4gICAgZW5hYmxlOiBib29sZWFuO1xuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIGNhbXBhaWduS2V5OiBzdHJpbmc7XG59XG4iXX0=